import Vue from 'vue'
import Router from 'vue-router'

import App from '../App.vue'
import Projects from '../components/Projects/Projects.vue'
import Project from '../components/Project/Project.vue'
import About from '../components/About/About.vue'
import projectsItems from '../data/projects.json'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Projects,
            alias: '/fr',
            name: 'projects_component',
            children: [          
                {
                    path: '/project/:projectId',
                    alias: '/fr/projet/:projectId',
                    component: Project,
                    name: 'project_component',
                    beforeEnter: (to, from, next) => {
                        function isValid (param) {
                            if (Object.keys(projectsItems).includes(param)) {
                                return true
                            } else {
                                return false                                
                            }
                        }

                        if (!isValid(to.params.projectId)) {
                            next({ name: 'projects_component' });
                        }

                        next();
                    }
                }
            ]
        },
        {
            path: '/about',
            component: About,
            alias: '/fr/a-propos',
            name: 'about_component'
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js